import React, {useEffect, useRef} from 'react'
import SectionHeader from '../components/SectionHeader'
import WorkExperienceSection from './WorkExperienceSection'
import profileImage from '../images/ProfilePictureLinkedIn.jpeg'

// Animations 
import {useSpring,animated } from'react-spring'
import useOnScreen from '../utility/useIntersection'

export default function AboutPage() {

    // State 
    const aboutPageRef = useRef()
    const aboutIsVisible = useOnScreen(aboutPageRef, "0px");

    console.log(aboutIsVisible)

    const animationClassName = aboutIsVisible?`about-page container page fade-in-section is-visible`:`about-page container page fade-in-section`

    return (
        <animated.div className={animationClassName} 
        id="about-page"
        ref = {aboutPageRef}
        >
            <SectionHeader 
            sectionHeading = 'III - About Me'
            sectionNumber =  '3'
            alignment = 'section-number-align-end' 
            headerAlignment = 'align-end'
            />

            <section className="about-layout">

                <div className="text">
                    <article className="low-contrast-color">
                    <h4 className="light-color">Introduction</h4>
                    <p>
                        Hello again! I am Krishna, a physics enthusiast from Hyderabad, India.
                        I recently completed the IB Diploma Programme and am an incoming student of Physics at the University of Warwick.
                        It has been a long passion of mine to build meaningful applications on
                        on varied things that interest me such as understanding astrophysics, economics, wildfires - albeit sometimes I do it just for fun.
                        With this spirit, I display my portfolio as a website.
                        I am currently looking for an internship opportunity wherein I can bring in my analytical ability and quantitative acumen to contribute to the team's work while fostering my skills.
                        Thank you for your time and have a great day!
                    </p>
                    </article>

                    <article>
                        <h4 className="light-color">Recent Work</h4>
                        <WorkExperienceSection 
                        title={"Research Assistant at UNESCO and Center for Civil Society"}
                        projectName={"Global Education Monitoring (GEM) 2021"}
                        pointsArray = {[
                            "Developed an Emailing software that helped reach 75% of the potential clientele", 
                            "Assisting and coordinating data collection among budget private schools in the state of Telangana, India for UNESCO’S GEM 2021 Report.", 
                            "Liaising with the heads of National Independent School Association, Telangana Recognized School Management Association, and district heads of budget private schools."
                        ]}
                        duration="2021"
                        
                        />
                    </article>
                        
                    <article className="education">
                        <h4 className="light-color">Education</h4>
                        <ul>
                            <li>
                                <h5 className="accent-color upper-case text-wrap">International Baccalaureate Diploma Program (IBDP)</h5>
                                <ul>
                                    <li className="low-contrast-color text-wrap">Scored 43/45 points and a 7 out of a possible 7 in subjects – Physics, Chemistry, Mathematics and Economics</li>
                                    <li className="low-contrast-color text-wrap">Institution: Johnson IBDP World School - Hyderabad, Telangana, India.</li>
                                </ul>
                            </li>
                            <li>
                                <h5 className="accent-color upper-case text-wrap">Secondary School Certificate (SSC) </h5>
                                <ul>
                                    <li className="low-contrast-color text-wrap">Scored 9.5/10 CGPA</li>
                                    <li className="low-contrast-color text-wrap">Institution: Slate the School - Hyderabad, Telangana, India.</li>
                                </ul>
                            </li>
                        </ul>
                    </article>

                </div>

                <div className="visual">
                    <img src={profileImage} alt="Krishna Bellamkonda profile pic" className="profile-pic"/>
                </div>

            </section>
        </animated.div>
    )
}
